import React, { useState, useEffect } from 'react';
import StyledBox from 'views/information-module/ReviewsView/ReviewsView.styles';
import { useTranslation } from 'next-i18next';
import { InfoPageTitle } from 'views/common/components';
import { CustomerExperienceSection } from 'views/information-module/ReviewsView/components';
import PATHS from 'lib/navigation/paths';
import generateMetaData from 'lib/utils/generateMetaData';
import Head from 'next/head';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { useGetReviewPageInfo } from 'views/information-module/ReviewsView/hooks/useGetReviewPageInfo';
import { usePageApiRequests } from 'views/information-module/ReviewsView/hooks/usePageApiRequests';
import { PAGE_REVIEWS_TYPES } from 'views/information-module/ReviewsView/utils/CONSTANTS';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import { ReviewsViewSkeleton } from 'views/information-module/ReviewsView';

const ReviewsView = (props) => {
  const { serverData, pageType } = props;
  const { t } = useTranslation(['fe_er_reviews_page', 'common_layout_v2']);
  const handleErrorResponse = useErrorsHandler();
  const appNavigator = useAppNavigator();
  const [data, setData] = useState(serverData);
  const { mainTitleObject, breadcrumbsObject } = useGetReviewPageInfo(
    pageType,
    data,
  );
  const [getReviewsData, getLocationReviewsData] = usePageApiRequests();

  const handlePaginationClick = (page) => {
    switch (pageType) {
      case PAGE_REVIEWS_TYPES.all_reviews:
        appNavigator.push(PATHS.reviews({ page }));
        break;
      case PAGE_REVIEWS_TYPES.location_review:
        appNavigator.push(
          PATHS.locationReviews(appNavigator.query.id, { page }),
        );
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (typeof window !== 'undefined' && !serverData) {
      switch (pageType) {
        case PAGE_REVIEWS_TYPES.all_reviews:
          getReviewsData(appNavigator.query?.page)
            .then((res) => {
              setData(res.data);
            })
            .catch((error) => {
              handleErrorResponse(error, false);
            });
          break;
        case PAGE_REVIEWS_TYPES.location_review:
          getLocationReviewsData(appNavigator.query?.page)
            .then((res) => {
              setData(res.data);
            })
            .catch((err) => {
              switch (err.response?.status) {
                case 403:
                  switch (err.response.data.error_code) {
                    case 'ER0001':
                      appNavigator.push(PATHS.locations());
                      break;
                    case 'ER0002':
                      appNavigator.push(
                        PATHS.locationReviews(err.response.data.new_slug),
                      );
                      break;
                    default:
                      handleErrorResponse(err, false);
                      break;
                  }
                  break;
                default:
                  handleErrorResponse(err, false);
                  break;
              }
            });
          break;
        default:
          break;
      }
    }
  }, [appNavigator.query.page, appNavigator.query.id]);

  return (
    <>
      {data ? (
        <StyledBox className="overFlowXHidden">
          {data.seo_values && <Head>{generateMetaData(data.seo_values)}</Head>}
          <InfoPageTitle
            mainTitleObject={mainTitleObject}
            breadcrumbsObject={breadcrumbsObject}
            buttonText={t('fe_er_reviews_page:start_reservation')}
            reservationData={{
              pickup_location_id: data.location?.id,
              dropoff_location_id: data.location?.id,
            }}
          />
          <CustomerExperienceSection
            customerExperience={data}
            handlePaginationClick={handlePaginationClick}
          />
          {/* <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(data?.structured_data),
            }}
          /> */}
        </StyledBox>
      ) : (
        <ReviewsViewSkeleton />
      )}
    </>
  );
};

export { ReviewsView };
